// Box content labeling options
export enum BoxContentLabelingOption {
  DELIVERR_PREP = "DELIVERR_PREP", // use Deliverr's prep offering
  DIY = "DIY", // seller
}
